/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationChannel } from './NotificationChannel';
import {
    NotificationChannelFromJSON,
    NotificationChannelFromJSONTyped,
    NotificationChannelToJSON,
    NotificationChannelToJSONTyped,
} from './NotificationChannel';

/**
 * 
 * @export
 * @interface PaginatedNotificationChannelList
 */
export interface PaginatedNotificationChannelList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedNotificationChannelList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationChannelList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationChannelList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<NotificationChannel>}
     * @memberof PaginatedNotificationChannelList
     */
    results: Array<NotificationChannel>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedNotificationChannelList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedNotificationChannelList interface.
 */
export function instanceOfPaginatedNotificationChannelList(value: object): value is PaginatedNotificationChannelList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedNotificationChannelListFromJSON(json: any): PaginatedNotificationChannelList {
    return PaginatedNotificationChannelListFromJSONTyped(json, false);
}

export function PaginatedNotificationChannelListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedNotificationChannelList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(NotificationChannelFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedNotificationChannelListToJSON(json: any): PaginatedNotificationChannelList {
    return PaginatedNotificationChannelListToJSONTyped(json, false);
}

export function PaginatedNotificationChannelListToJSONTyped(value?: PaginatedNotificationChannelList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(NotificationChannelToJSON)),
        'num_pages': value['numPages'],
    };
}

